import { render, staticRenderFns } from "./RequestConfirmation.vue?vue&type=template&id=2a5a289d&scoped=true&"
import script from "./RequestConfirmation.vue?vue&type=script&lang=js&"
export * from "./RequestConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./RequestConfirmation.vue?vue&type=style&index=0&id=2a5a289d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5a289d",
  null
  
)

export default component.exports